import createNumberMask from 'text-mask-addons/dist/createNumberMask';
import { VISIBLE_DATE_SEPARATOR } from 'utils/date';
import { CurrencySymbol } from 'shared/interface/globalInterface';

export const dateMask = [
  /\d/,
  /\d/,
  VISIBLE_DATE_SEPARATOR,
  /\d/,
  /\d/,
  VISIBLE_DATE_SEPARATOR,
  /\d/,
  /\d/,
  /\d/,
  /\d/,
];
export const telephoneMask = [/\d/, /\d/, /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/];
export const sortCodeMask = [/\d/, /\d/, '-', /\d/, /\d/, '-', /\d/, /\d/];
export const postcodeMask = (rawValue: string) => {
  const numberOrChar = /[a-zA-Z0-9]/;
  const pattern: Array<any> = [...Array(rawValue.length)].map(() => numberOrChar);
  const splittedValue = rawValue.replace(' ', '').split('');
  const indexToSpace = splittedValue.length - 3;

  pattern.splice(indexToSpace, 0, ' ');

  return pattern;
};

export const caseNumberMask = (caseNumber: string) => {
  return caseNumber
    .replace(' ', '')
    .split('')
    .map((_) => /[a-zA-Z0-9]/);
};

export const currencyMask = createNumberMask({
  prefix: '',
  allowNegative: true,
});

export const decimalPrefixedCurrencyMask = createNumberMask({
  prefix: `${CurrencySymbol} `,
  allowNegative: true,
  allowDecimal: true,
});

export const decimalCurrencyMask = createNumberMask({
  prefix: '',
  allowNegative: true,
  allowDecimal: true,
});

export const MBCcurrencyMask = createNumberMask({
  prefix: `${CurrencySymbol} `,
  allowNegative: true,
});

export const percentageMask = createNumberMask({
  prefix: '',
  suffix: '%',
  includeThousandsSeparator: false,
});

export const percentageDecimalMask = createNumberMask({
  prefix: '',
  suffix: '%',
  includeThousandsSeparator: false,
  allowDecimal: true,
});

export const adviserFCAMask = [/[a-zA-Z]/, /[a-zA-Z]/, /[a-zA-Z]/, /\d/, /\d/, /\d/, /\d/, /\d/];

export const FCAMask = [/\d/, /\d/, /\d/, /\d/, /\d/, /\d/];

export const numberMask = createNumberMask({
  prefix: '',
  includeThousandsSeparator: false,
  allowLeadingZeroes: true,
  allowNegative: true,
});

export const decimalNumberMask = createNumberMask({
  prefix: '',
  includeThousandsSeparator: true,
  allowDecimal: true,
});

export const yearsMask = createNumberMask({
  prefix: '',
  suffix: ' years',
  includeThousandsSeparator: false,
});
export const accNumberMask = [/\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/];
